import {useAuthAxios} from 'hooks/api/useAuthAxios'
import {Params} from './useDownloadProcedureCsv'

export const usePostProcedureCsvRequest = () => {
  const authAxios = useAuthAxios()
  return async (data: Params) => authAxios.post('/api/export_procedure_csv_requests', data)
}
